import { IllegalStateExceptionkoljg5n0nrlr as IllegalStateException } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  get_partyIdAdapter2v7zx778kk10s as get_partyIdAdapter,
  get_pinIdAdapter27yg3a7qzsov7 as get_pinIdAdapter,
} from '../../../adapter/Adapter.mjs';
import { get_StringAdapter1plpsgiy8rwhj as get_StringAdapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { SavePinInputnc3r3ek8pldn as SavePinInput } from '../SavePinInput.mjs';
import { Adapter1t72m9xaryzfb as Adapter } from '../../../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapter.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var SavePinInput_InputAdapterClass;
function SavePinInput_InputAdapter() {
  if (SavePinInput_InputAdapterClass === VOID) {
    class $ {
      g40(reader, customScalarAdapters) {
        throw IllegalStateException().o('Input type used in output position');
      }
      q6w(writer, customScalarAdapters, value) {
        writer.c4d('partyId');
        get_partyIdAdapter().h40(writer, customScalarAdapters, value.b6v_1);
        writer.c4d('pinId');
        get_pinIdAdapter().h40(writer, customScalarAdapters, value.c6v_1);
        writer.c4d('icon');
        get_StringAdapter().h40(writer, customScalarAdapters, value.d6v_1);
        writer.c4d('name');
        get_StringAdapter().h40(writer, customScalarAdapters, value.e6v_1);
      }
      h40(writer, customScalarAdapters, value) {
        return this.q6w(writer, customScalarAdapters, value instanceof SavePinInput() ? value : THROW_CCE());
      }
    }
    initMetadataForObject($, 'SavePinInput_InputAdapter', VOID, VOID, [Adapter()]);
    SavePinInput_InputAdapterClass = $;
  }
  return SavePinInput_InputAdapterClass;
}
var SavePinInput_InputAdapter_instance;
function SavePinInput_InputAdapter_getInstance() {
  return SavePinInput_InputAdapter_instance;
}
//region block: init
SavePinInput_InputAdapter_instance = new (SavePinInput_InputAdapter())();
//endregion
//region block: exports
export {
  SavePinInput_InputAdapter_instance as SavePinInput_InputAdapter_instance2wfb6ahst365k,
};
//endregion

//# sourceMappingURL=SavePinInput_InputAdapter.mjs.map
